module.exports = __webpack_public_path__ + "img/chatbot-float.4f6e3dae.webp";